import clsx from 'clsx';
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ClientContact } from './clientContacts/ClientContact';
import { ClientDepartment } from './clientDepartment/ClientDepartment';
import OffCanvas from '../../common/OffCanvas';
import { ClientContactForm } from "../client/clientContacts/ClientContactForm";
import { ClientDepartmentForm } from "../client/clientDepartment/ClientDepartmentForm";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Dropdown } from 'react-bootstrap';
import { resetSelectedRecordObjectInState as resetContactObject } from "./clientContacts/ClientContactSlice";
import { resetSelectedRecordObjectInState as resetDepartmentObject } from "./clientDepartment/ClientDepartmentSlice";
import fetchAPI from '../../common/fetchAPI';
import parse from 'html-react-parser';
import { setItemStatus, sortData, getValueFromResource } from '../../common/timeLiveFunction';
import { getClientDataByIAsync, resetSelectedRecordObjectInState, deleteClientAsync } from './AccountClientSlice';
import AccountClientForm from './AccountClientForm';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { ShowToast } from '../../common/Toastr';
import { getParentChildPagePermissionsAsync } from '../../common/GlobalSlice';
import Loader from '../../common/Loader';
import * as Sentry from "@sentry/react";

const initialValuesForPermissions = {
    IsProjectList: false,
    IsClientContactList: false,
    IsClientContactAdd: false,
    IsClientDepartmentList: false,
    IsClientDepartmentAdd: false,
    permissionList: []
}

const initialSortValues = {
    sortOrder: 'asc',
    sortColumn: 'ProjectName'
}

export const AccountPartySummary = (props: any) => {
    const Parent_SystemSecurityCategoryPageId: string = "8";
    //local storage work comment
    // const storedObjectData = localStorage.getItem('objClient');
    // const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    // const { AccountClientId, AccountClientName } = objectData;
    // const { AccountClientName } = objectData;
    const { AccountClientId } = useParams();
    const AccountPartyId = AccountClientId;
    const { t } = useTranslation();
    const [tab, setTab] = useState('Projects');
    const dispatch = useAppDispatch();
    const { selectedRecord } = useAppSelector((state) => state.clientContact)
    const [assignedProjectsArray, setAssignedProjectsArray] = useState<any | ''>([]);
    const navigate = useNavigate();
    const [childs, setChilds] = useState(initialValuesForPermissions);
    const { decimalPlaces, cultureInfoName, IsList, IsAdd, IsEdit, IsDelete, isLoading: isLoading_globalState } = useAppSelector((state) => state.globalState);
    const [isLoading_Project, setIsLoading_Project] = useState(false);
    const [isReload_Project, setIsReload_Project] = useState(false);
    const { isLoading } = useAppSelector((state) => state.accountClient);
    const [zIndex, setZIndex] = useState(1030);
    const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
    const [clientName, setSetClientName] = useState('')
    // const [hoveredColumn, setHoveredColumn] = useState(null);

    // Function to handle scroll event
    const handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > 0) {
            setZIndex(0); // Lower z-index when scrolling
        } else {
            setZIndex(1030); // Reset z-index to original when at the top
        }
    };

    // Set up scroll event listener
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const setActiveTab = (tab: string) => {
        if (tab === 'Projects') {
            setIsReload_Project(true);
        }
        setTab(tab);
    }

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (Parent_SystemSecurityCategoryPageId && Parent_SystemSecurityCategoryPageId !== '') {
                getPermissions(Parent_SystemSecurityCategoryPageId, "31,96,97")
            }
        }
        fetchPagePermissions();
    }, [dispatch]);

    const getPermissions = (SystemSecurityCategoryPageId: string, ChildSystemSecurityCategoryPageIds: string) => {
        dispatch(getParentChildPagePermissionsAsync({ SystemSecurityCategoryPageId: SystemSecurityCategoryPageId, ChildSystemSecurityCategoryPageIds: ChildSystemSecurityCategoryPageIds }))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.ParentPermission) {
                    if (originalPromiseResult.ParentPermission.IsList && originalPromiseResult.ChildPermission) {
                        const childPermission: any = originalPromiseResult.ChildPermission;
                        const isProjectList = childPermission.filter((x: any) => x.Id === 31)[0].IsList;
                        const isClientContactList = childPermission.filter((x: any) => x.Id === 96)[0].IsList;
                        const isClientContactAdd = childPermission.filter((x: any) => x.Id === 96)[0].IsAdd;
                        const isClientDepartmentList = childPermission.filter((x: any) => x.Id === 97)[0].IsList;
                        const isClientDepartmentAdd = childPermission.filter((x: any) => x.Id === 97)[0].IsAdd;
                        setChilds({
                            ...childs,
                            IsProjectList: isProjectList,
                            IsClientContactList: isClientContactList,
                            IsClientContactAdd: isClientContactAdd,
                            IsClientDepartmentList: isClientDepartmentList,
                            IsClientDepartmentAdd: isClientDepartmentAdd
                        });
                        if (isProjectList) {
                            setTab('Projects');
                        } else if (isClientContactList) {
                            setTab('Contacts');
                        } else if (isClientDepartmentList) {
                            setTab('Department');
                        }
                    }
                    else {
                        navigate('../error/403');
                    }
                }
                else {
                    navigate('../error/403');
                }
            })
            .catch((rejectedValueOrSerializedError) => {
                 Sentry.captureException(rejectedValueOrSerializedError);
            })
    }

    useEffect(() => {
        getAssignedProjects();
    }, [])

    useEffect(() => {
        if (isReload_Project) {
            getAssignedProjects();
        }
    }, [isReload_Project])

    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [selectedOffCanvas, setSelectedOffCanvas] = useState({
        "name": getValueFromResource('Add Client Contact', dispatch, t),
        "width": "700px",
        "componentName": < ClientContactForm AccountPartyId={AccountPartyId} t={t} />
    });

    const handleOnClickEvent = (selectedObject: any, Name: string, IsEditMode: boolean) => {
        if (Name === "ClientContact" && IsEditMode === false) {
            dispatch(resetContactObject());
        }
        else if (Name === "ClientDepartment" && IsEditMode === false) {
            dispatch(resetDepartmentObject());
        }
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }

    const getAssignedProjects = async () => {
        let Id = AccountPartyId;
        if (Id) {
            setIsLoading_Project(true);
            const response = await fetchAPI(`api/V2/Projects/AssignedProjects/` + Id, 'Get', '', true);
            const json = await response.json();
            let assignedProjects = json["AssignedProjects"];
            setSetClientName(json["AccountClient"][0].ClientName);
            if (Object.keys(assignedProjects).length === 0) {
                setAssignedProjectsArray([]);
            }
            else {
                //setAssignedProjectsArray(json.Data);
                setAssignedProjectsArray(sortData(assignedProjects, clientSideSorting.sortOrder, clientSideSorting.sortColumn));
            }
            // if (Object.keys(json.Data).length === 0) {
            //     setAssignedProjectsArray([]);
            // }
            // else {
            //     //setAssignedProjectsArray(json.Data);
            //     setAssignedProjectsArray(sortData(json.Data, clientSideSorting.sortOrder, clientSideSorting.sortColumn));
            // }
            setIsLoading_Project(false);
            setIsReload_Project(false);
        }
        else {
            setAssignedProjectsArray([]);
        }
    }

    const determineDueStatus = (deadline: any, startDate: any) => {
        const now = new Date();
        let status: string = "Soon Due"
        if (deadline) {
            const deadlineDate = new Date(deadline);
            if (now > deadlineDate) {
                status = 'Overdue';
            } else if (now.getDate() === deadlineDate.getDate()) {
                status = 'Due';
            } else if (now < deadlineDate) {
                status = 'Soon Due';
            }
        } else if (startDate && now < new Date(startDate)) {
            status = 'Start Soon';
        }
        return status;
    }

    const onClientDeleteClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteClientAsync(AccountClientId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            if (originalPromiseResult.StatusCode === "200") {
                                ShowToast("Client Deleted Successfully", 'Success', "success", "toast-top-right")
                                navigate('/client');
                            }
                            else {

                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            }

                        })
                        .catch((rejectedValueOrSerializedError) => {
                             Sentry.captureException(rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                 Sentry.captureException(error);
            });

    }

    const navigateToProjectSummary = (obj: any) => {
        localStorage.setItem('objProject', JSON.stringify(obj));
        navigate(`/accountprojectsummary/${obj.AccountProjectId}`);
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        setClientSideSorting({
            ...clientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn
        });
        let sortedTeamResponse = [...assignedProjectsArray];
        setAssignedProjectsArray(sortData(sortedTeamResponse, sortOrder, sortColumn));
    }

    return (
        <>
            {(isLoading_globalState || isLoading_Project || isLoading) && <Loader />}
            <div className='row'>
                <div className="card card-custom admin-card">
                    <div className="card-header sticky-top bg-white dropdown-zindex fixed-top">
                        <h3 className="card-title fw-bold headerTitle">{clientName}</h3>
                        <div className="card-toolbar align-items-center">

                            <div className="btn-group me-2" >
                                <button
                                    type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i className="fa fa-plus mb-1 me-1"></i>
                                    {/* {t('Add')} */}
                                    {getValueFromResource('Add ', dispatch, t)}
                                    <i className=""></i>
                                    <i className="fa fa-angle-down"></i>
                                </button>
                                <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-175px" role="menu">
                                    {childs.IsClientContactAdd &&
                                        <div className='menu-hover-bg-sec'>
                                            <Dropdown.Item
                                                id="kt_OffCanvas"
                                                className="menu-item me-lg-0"
                                                onClick={() => handleOnClickEvent({
                                                    "name": getValueFromResource('Add Client Contact', dispatch, t),
                                                    "width": "700px",
                                                    "componentName": < ClientContactForm AccountPartyId={AccountPartyId} t={t} />
                                                }, "ClientContact", false)}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    {/* <i className="bi bi-plus fs-6 iconColor"> */}
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    {/* </i> */}
                                                </span>
                                                <span className="menu-title custom-menu-fontsize">
                                                    {/* {`${t('Add Client Contact')}`} */}
                                                    {getValueFromResource('Add Client Contact', dispatch, t)}
                                                </span>
                                            </Dropdown.Item>
                                        </div>
                                    }
                                    {childs.IsClientDepartmentAdd &&
                                        <div className='menu-hover-bg-sec'>
                                            <Dropdown.Item
                                                id="kt_OffCanvas"
                                                className="menu-item me-lg-0"
                                                onClick={() => handleOnClickEvent({
                                                    "name": getValueFromResource('Add Client Department', dispatch, t),
                                                    "width": "700px",
                                                    "componentName": < ClientDepartmentForm AccountPartyId={AccountPartyId} t={t} />
                                                }, "ClientDepartment", false)}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    {/* <i className="bi bi-book fs-6 iconColor"> */}
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    {/* </i> */}
                                                </span>
                                                <span className="menu-title custom-menu-fontsize">
                                                    {/* {`${t('Add Client Department')}`} */}
                                                    {getValueFromResource('Add Client Department', dispatch, t)}
                                                </span>
                                            </Dropdown.Item>
                                        </div>
                                    }
                                </ul>
                            </div>
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i className="fa fa-cog mb-1 me-1"></i>
                                    {/* {t('Options')} */}
                                    {getValueFromResource('Options', dispatch, t)}
                                    <i className=""></i>
                                    <i className="fa fa-angle-down"></i>
                                </button>
                                <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-175px" role="menu">
                                    {IsEdit &&
                                        <div className='menu-hover-bg-sec'>

                                            <Dropdown.Item
                                                id="kt_OffCanvas"
                                                className="menu-item me-lg-0"

                                                onClick={() => {
                                                    dispatch(getClientDataByIAsync({ AccountClientId: AccountClientId, decimalPlaces: decimalPlaces, cultureInfoName: cultureInfoName }))
                                                        .unwrap()
                                                        .then((originalPromiseResult) => {
                                                            handleOnClickEvent({
                                                                "name": getValueFromResource('Update Client', dispatch, t),
                                                                "width": "700px",
                                                                "componentName": <AccountClientForm t={t}
                                                                />
                                                            }, "Clients", true);
                                                        })
                                                        .catch((rejectedValueOrSerializedError) => {
                                                        })
                                                }}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-title custom-menu-fontsize">
                                                    {/* {`${t('Edit Client')}`} */}
                                                    {getValueFromResource('Edit Client', dispatch, t)}
                                                </span>
                                            </Dropdown.Item>

                                        </div>
                                    }
                                    {IsDelete &&
                                        <>
                                            <div className='separator mb-1 mt-1 opacity-75'></div>
                                            <div className='menu-hover-bg-danger'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0"
                                                    onClick={() => { onClientDeleteClick() }}
                                                >
                                                    <span className="menu-icon custom-menu mb-2">
                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title delete-menu custom-menu-fontsize">
                                                        {/* {`${t('Delete')}`} */}
                                                        {getValueFromResource('Delete', dispatch, t)}
                                                    </span>
                                                </Dropdown.Item>
                                            </div>
                                        </>
                                    }

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card-body AccountPartySummary hideVerticalScroll">
                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-6' role='tablist'>
                            {/* <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap ' role='tablist'> */}
                            {childs.IsProjectList &&
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Projects' })}
                                        onClick={() => setActiveTab('Projects')}
                                        role='tab'
                                    >
                                        {/* {t('Projects')} */}
                                        {getValueFromResource('Projects', dispatch, t)}
                                    </a>
                                </li>
                            }
                            {childs.IsClientContactList &&
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Contacts' })}
                                        onClick={() => setActiveTab('Contacts')}
                                        role='tab'
                                    >
                                        {/* {t('Contacts')} */}
                                        {getValueFromResource('Contacts', dispatch, t)}
                                    </a>
                                </li>
                            }
                            {childs.IsClientDepartmentList &&
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Department' })}
                                        onClick={() => setActiveTab('Department')}
                                        role='tab'
                                    >
                                        {/* {t('Department')} */}
                                        {getValueFromResource('Department', dispatch, t)}
                                    </a>
                                </li>
                            }
                        </ul>
                        <div className='tab-content pt-0' >
                            <div className={clsx('tab-pane', { active: tab === 'Projects' })}>
                                {/* <div className="card">
                                    <div className="card-body "> */}
                                {childs.IsProjectList &&
                                    <>
                                        {tab === 'Projects' &&
                                            <div className="table-responsive">
                                                <table className="table table-row-bordered  align-middle gs-1 gy-2 gx-1" >
                                                    <thead>
                                                        <tr className="thHeading align-middle ">
                                                            <th className='w-25px'
                                                            // onMouseEnter={() => handleMouseEnter(0)}
                                                            // onMouseLeave={handleMouseLeave}
                                                            >
                                                                {clientSideSorting.sortColumn === 'IsDisabled' ?
                                                                    clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                    </span>
                                                                    :
                                                                    // hoveredColumn === 0 && 
                                                                    <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                    </>}
                                                            </th>
                                                            <th className='w-25px'
                                                            // onMouseEnter={() => handleMouseEnter(1)}
                                                            // onMouseLeave={handleMouseLeave}
                                                            >
                                                                {clientSideSorting.sortColumn === 'StartDate' ?
                                                                    clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "StartDate") }}>
                                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "StartDate") }}>
                                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                    </span>
                                                                    :
                                                                    // hoveredColumn === 1 && 
                                                                    <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "StartDate") }}>
                                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "StartDate") }}>
                                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                    </>}
                                                            </th>
                                                            <th style={{ width: '40%' }}
                                                            // onMouseEnter={() => handleMouseEnter(2)}
                                                            // onMouseLeave={handleMouseLeave}
                                                            >
                                                                {/* {t('Name')} */}
                                                                {getValueFromResource('Name', dispatch, t)}
                                                                {clientSideSorting.sortColumn === 'ProjectName' ?
                                                                    clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                    </span>
                                                                    :
                                                                    // hoveredColumn === 2 && 
                                                                    <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                    </>}
                                                            </th>
                                                            <th style={{ width: '20%' }}
                                                            // onMouseEnter={() => handleMouseEnter(3)}
                                                            // onMouseLeave={handleMouseLeave}
                                                            >
                                                                {/* {t('Status')} */}
                                                                {getValueFromResource('Status', dispatch, t)}
                                                                {clientSideSorting.sortColumn === 'Status' ?
                                                                    clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                    </span>
                                                                    :
                                                                    // hoveredColumn === 3 && 
                                                                    <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                    </>}
                                                            </th>
                                                            <th style={{ width: '40%' }}
                                                            // onMouseEnter={() => handleMouseEnter(4)}
                                                            // onMouseLeave={handleMouseLeave}
                                                            >
                                                                {/* {t('Team')} */}
                                                                {getValueFromResource('Team', dispatch, t)}
                                                                {clientSideSorting.sortColumn === 'TeamMembers' ?
                                                                    clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TeamMembers") }}>
                                                                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                    </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TeamMembers") }}>
                                                                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                    </span>
                                                                    :
                                                                    // hoveredColumn === 4 && 
                                                                    <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TeamMembers") }}>
                                                                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TeamMembers") }}>
                                                                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                    </>}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {assignedProjectsArray.length === 0 && <tr><td colSpan={5}><p className='noDataFound'>
                                                            {/* {t('No Record Found')} */}
                                                            {getValueFromResource('No Record Found', dispatch, t)}
                                                        </p>
                                                        </td>
                                                        </tr>}
                                                        {assignedProjectsArray.length > 0 && assignedProjectsArray.map((assignedProjectsDetail: any, i: any) => (
                                                            <tr key={i}>
                                                                <td>
                                                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus((assignedProjectsDetail.IsDisabled === 'No' || !assignedProjectsDetail.IsDisabled) ? "Active" : "InActive"))}>
                                                                        {(assignedProjectsDetail.IsDisabled === 'No' || !assignedProjectsDetail.IsDisabled) ? "Active" : "InActive"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(determineDueStatus(assignedProjectsDetail.Deadline, assignedProjectsDetail.StartDate)))}>
                                                                        {determineDueStatus(assignedProjectsDetail.Deadline, assignedProjectsDetail.StartDate)}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        className='text-dark fw-bold d-block cursor'
                                                                        onClick={() => {
                                                                            navigateToProjectSummary({
                                                                                "AccountProjectId": assignedProjectsDetail.AccountProjectId,
                                                                                "ProjectCode": assignedProjectsDetail.ProjectCode,
                                                                                "ProjectName": assignedProjectsDetail.ProjectName,
                                                                                "Status": assignedProjectsDetail.Status,
                                                                                "StartDate": assignedProjectsDetail.StartDate,
                                                                                "Deadline": assignedProjectsDetail.Deadline,
                                                                                "ProjectBillingRateTypeId": assignedProjectsDetail.ProjectBillingRateTypeId,
                                                                                "IsSummaryFrom": 'View'
                                                                            });
                                                                        }}
                                                                    >
                                                                        {assignedProjectsDetail.ProjectName}
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(assignedProjectsDetail.Status))}>
                                                                        {assignedProjectsDetail.Status}
                                                                    </span>
                                                                </td>
                                                                <td >
                                                                    <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                                        <div className='d-flex align-items-center flex-shrink-0 me-5'>
                                                                            <div className='symbol-group symbol-hover flex-shrink-0 me-2'>
                                                                                {assignedProjectsDetail.TeamMembers != null && parse(`${assignedProjectsDetail.TeamMembers}`)}
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        }
                                    </>
                                }
                                {/* </div>
                                </div> */}
                            </div>
                        </div>

                        <div className='tab-content pt-0' >
                            <div className={clsx('tab-pane', { active: tab === 'Contacts' })}>
                                {/* <div className="card ">
                                    <div className="card-body AccountPartySummary" > */}
                                {childs.IsClientContactList &&
                                    <>
                                        {tab === 'Contacts' &&
                                            <ClientContact onhandleOnClickEvent={handleOnClickEvent} t={t} AccountPartyId={AccountPartyId} />
                                        }
                                    </>
                                }
                                {/* </div>
                                </div> */}
                            </div>
                        </div>

                        <div className='tab-content pt-0' >
                            <div className={clsx('tab-pane', { active: tab === 'Department' })}>
                                {/* <div className="card ">
                                    <div className="card-body"> */}
                                {childs.IsClientDepartmentList &&
                                    <>
                                        {tab === 'Department' &&
                                            <ClientDepartment onhandleOnClickEvent={handleOnClickEvent} t={t} AccountPartyId={AccountPartyId} />
                                        }
                                    </>}

                                {/* </div>
                                </div> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <OffCanvas
                isOpen={showOffCanvas}
                onClose={() => setShowOffCanvas(false)}
                obj={selectedOffCanvas}

            />

        </>
    )
}


